import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import { CheckToken } from "../../login/AccessToken";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { ChangeCursor } from "./MiscFunctions";
import { Card, Col, Container, Row } from "react-bootstrap";
import { toast } from "react-toastify";
function ChatPdf() {
    const { register, handleSubmit, formState: { errors }, getValues, watch, setValue } = useForm();
    const { register: register1, handleSubmit: handleSubmit1, formState: { errors: errors1 }, getValues: getValues1, watch: watch1, setValue: setValue1 } = useForm();
    const [submitted, setSubmitted] = useState(false);
    const [authToken, setAuthToken] = useState(sessionStorage.getItem("accessToken") !== undefined &&
        sessionStorage.getItem("accessToken") !== null ? sessionStorage.getItem("accessToken") : "");

    const headers = {
        Authorization: `Bearer ${authToken}`,
    };
    const [fileNameSelected, setFileNameSelected] = useState("");
    const [sourceId, setSourceId] = useState("");
    const history = useHistory();
    const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;

    const upload = watch("uploaded_file");
    useEffect(() => {
        console.log(upload);
        if (upload !== undefined && upload.length > 0) {
            setFileNameSelected(upload);
        }
    }, [upload]);

    useEffect(() => {
        if (
            sessionStorage.getItem("accessToken") == undefined &&
            sessionStorage.getItem("accessToken") == null
        ) {
            history.push("/login");
        }
        if (
            sessionStorage.getItem("subscriptionType") !== undefined &&
            sessionStorage.getItem("subscriptionType") !== null &&
            sessionStorage.getItem("subscriptionType").includes("Connector/Adaptor")
        ) {
            history.push("/hlthtek-demo");
        }
        setValue("facility_id", sessionStorage.getItem("facility_name"));
    }, []);

    const Token = () => {
        const check = CheckToken();
        setAuthToken(sessionStorage.getItem("accessToken"));
        return check;
    };

    const onSubmit = (data, e) => {
        e.preventDefault();
        //ChangeCursor();
        if (Token()) {
            const file = document.querySelector("input[type=file]").files[0];
            const extension = file.name.split(".").pop();
            const fileName =
                file.name.slice(0, 5) + "." + extension;

            if (file !== undefined) {

                var bodyFormData = new FormData();
                bodyFormData.append("HIP_ID", sessionStorage.getItem("facility_name"));
                bodyFormData.append("documentType", "pdf");
                bodyFormData.append("file", file);

                axios
                    .post(
                        `${REACT_APP_BACKEND_ROUTE_URL}add_pdf_via_upload/`,
                        bodyFormData,
                        {
                            headers: headers,
                        }
                    )
                    .then((response) => {
                        console.log(response)
                        setSourceId(response.data.source_id)
                        //ChangeCursor();
                    })
                    .catch((err) => {
                        console.log(err);
                        toast.error(err);
                        //ChangeCursor();
                    });

            }
        } else {
            toast.error("Please choose a file first!!");
        }
        setSubmitted(true);
    };

    const chat = (data, e) => {
        e.preventDefault();
        //ChangeCursor();

        var postdata = {}

        postdata.sourceId = sourceId
        postdata.messages = []
        var message = {
            "role": "user",
            "content": data.question
        }
        postdata.messages.push(message)
        axios
            .post(
                `${REACT_APP_BACKEND_ROUTE_URL}chat_with_pdf/`,
                postdata,
                {
                    headers: headers,
                }
            )
            .then((response) => {
                console.log(response)
                // setSourceId(response.source_id)
                toast.success(response.data.answer)
                //ChangeCursor();
            })
            .catch((err) => {
                console.log(err);
                toast.error(err);
                //ChangeCursor();
            });
    }
    return (
        <div>
            <h1 style={{ textAlign: 'center' }}>Chat with PDF</h1>
            <div
                className="col-sm-12 col-md-12 col-lg-7"
                style={{ marginLeft: "20%" }}
            >
                <div className="contact-panel mb-50">
                    <form
                        className="contact-panel__form"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <div className="row">
                            <div className="col-sm-4 col-md-4 col-lg-4">
                                <label
                                    htmlFor="contained-button-file"
                                    id="button-upload"
                                    className="btn btn__secondary btn__rounded btn__block  btn__xhight mt-4"
                                >
                                    <input
                                        type="file"
                                        id="contained-button-file"
                                        hidden
                                        {...register("uploaded_file", {
                                            required: "File Upload is required.",
                                        })}
                                    />
                                    Choose file
                                </label>
                                {errors.uploaded_file && !submitted && (
                                    <p className="errorMsg">{errors.uploaded_file.message}</p>
                                )}
                            </div>
                            <div
                                className="col-sm-4 col-md-4 col-lg-4"
                                style={{ paddingTop: "40px" }}
                            >
                                {fileNameSelected !== undefined && fileNameSelected.length > 0
                                    ? "Selected File : " + fileNameSelected[0].name
                                    : []}
                            </div>
                            <div className="col-12">
                                <button
                                    type="submit"
                                    className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                                >
                                    <span>Upload PDF</span>{" "}
                                    <i className="icon-arrow-right"></i>
                                </button>
                                <div className="contact-result"></div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div
                className="col-sm-12 col-md-12 col-lg-7"
                style={{ marginLeft: "20%" }}
            >
                <div className="contact-panel mb-50">
                    <form
                        className="contact-panel__form"
                        onSubmit={handleSubmit1(chat)}
                    >
                        <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-6">
                                <div className="form-group">
                                    <i className="icon-news form-group-icon"></i>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter your Question"
                                        name="question"
                                        {...register1("question", {
                                            required: "Question is required.",
                                            minLength: {
                                                value: 4,
                                                message: "Minimum Length is 4.",
                                            },
                                        })}
                                    />
                                    {errors1.question && (
                                        <p className="errorMsg" style={{ color: "red" }}>
                                            {errors1.question.message}
                                        </p>
                                    )}
                                </div>
                            </div>
                            <div className="col-12">
                                <button
                                    type="submit"
                                    className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                                >
                                    <span>Ask</span>{" "}
                                    <i className="icon-arrow-right"></i>
                                </button>
                                <div className="contact-result"></div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ChatPdf;
